import { getElectronAPI, isDesktopApp } from '@/desktop/electronApi';
import { useDesktopSessionStore } from '@/desktop/desktopSessionStore';
import { authApi } from '@/services/api';

/**
 * After cloud login: put Frappe sid on the API host via Electron (file:// cannot use document.cookie).
 * Always key vault storage with Frappe user.name (same as enroll serverUserId).
 */
export async function persistDesktopCloudSession(opts: {
  sid: string;
  userId: string;
  fullName?: string;
}): Promise<boolean> {
  if (!isDesktopApp()) return false;
  const api = getElectronAPI();
  if (!api?.cloudSession?.apply) return false;
  const sid = String(opts.sid || '').trim();
  const userId = String(opts.userId || '').trim();
  if (!sid || sid === 'Guest' || !userId) return false;
  try {
    await api.cloudSession.apply({
      sid,
      userId,
      fullName: opts.fullName,
      serverUserId: userId,
    });
    useDesktopSessionStore.getState().setCloudSessionExpired(false);
    return true;
  } catch {
    useDesktopSessionStore.getState().setCloudSessionExpired(true);
    return false;
  }
}

/** After PIN unlock: probe cloud; set expired banner if Guest / 401. */
export async function verifyDesktopCloudSessionAfterUnlock(opts?: {
  cloudApplied?: boolean;
  serverUserId?: string;
}): Promise<boolean> {
  if (!isDesktopApp()) return true;
  try {
    await authApi.getCurrentUser();
    useDesktopSessionStore.getState().setCloudSessionExpired(false);
    return true;
  } catch {
    // Clear dead sid from injector + vault so unlock does not reapply a rejected session.
    try {
      const serverUserId =
        opts?.serverUserId || useDesktopSessionStore.getState().activeProfile?.serverUserId;
      await getElectronAPI()?.cloudSession?.clear(
        serverUserId ? { serverUserId } : undefined,
      );
    } catch {
      /* ignore */
    }
    useDesktopSessionStore.getState().setCloudSessionExpired(true);
    return false;
  }
}
